export const toRadialGradient = (startEnd: [string, string?]) => {
  return `radial-gradient(circle, ${startEnd[0]} 0%, ${
    startEnd[1] ?? startEnd[0]
  } 100%)`;
};
